module.exports = __webpack_public_path__ + "static/media/Q3-10.58be7b98.jpg";